import { format } from 'date-fns';
import React from 'react';
import { Table } from 'reactstrap';
const FirstSection = ({
  date,
  billingAddress,
  locations,
  companyField,
  proposalData,
  getBoxSumAmount,
  getLocationSumAmount,
}) => {
  return (
    <div className="loa-doc-page">
      <p>
        By signing the EPIK Proposal above, Customer hereby acknowledges and accepts the following
        terms:
      </p>
      <p className="numbered-paragraphs no-break">
        <span>1.</span>
        Customer acknowledges that EPIK or its authorized installation partner will install the EPIK
        unit ordered by Customer. Installation will include secure attachment of the unit to the
        designated site, powering up of the unit, verification of 4G connectivity and reception,
        verified connection to all EPIK Network Operation Center (NOC) facilities and databases, and
        connection from the unit to an EPIK-provided punchdown block for each ordered phone number.
        Customer will be responsible for ordering cross-connect services from its chosen 3rd-party
        vendors as applicable to take EPIK services from the punchdown block to customer’s existing
        telecom infrastructure or devices. EPIK will provide up to a $150 rebate to Customer that
        can be used for such 3rd-party vendor expenses. To qualify for rebate, Customer must submit
        vendor invoices to EPIK which explicitly refer to the cross-connect to the EPIK unit in
        order to claim the rebate. Customer will work with 3rd-party vendors to ensure the invoices
        meet the language requirement. Rebates checks will be mailed to customer within 30 days of
        receipt of such qualifying invoices. Invoices less than $150 will be rebated the amount of
        the invoice. Invoices may be mailed to EPIK Installation Rebates, ATTN: Finance, 24800
        Chrisanta Drive Suite 230, Mission Viejo, CA 92691.
        {/* hidden */}
        <p hidden className="numbered-paragraphs no-break">
          <span>a.</span>
          Demarc Installation is defined as the physical point at which the public network ends
          (i.e. at the Appliance) and Customer’s private internal network begins.
        </p>
      </p>
      <p className="numbered-paragraphs no-break">
        <span>2.</span>
        Customer will provide an EPIK-ready environment for installation. If Customer’s chosen
        installation site does not provide sufficient wireless reception to the required 4G network
        for the EPIK unit, Customer will be responsible to pay for the necessary antenna(s),
        required cable run(s) and associated labor to install such facilities.
      </p>
      <p className="numbered-paragraphs no-break">
        <span>3.</span>
        At least 3 business days prior to the installation date, Customer will give advanced written
        notice to EPIK advising of any required preparation the installer must make in order to gain
        access to the installation site on the day of install. Such notice would advise EPIK of any
        site safety requirements (such as hard hats, steel toed shoes, safety glasses, etc.), site
        contact information, directions, or other advice that would allow the installer full access
        to the installation site. Should Customer not provide such information in advance and the
        installer is either turned away or cannot gain or find access to the site, Customer will be
        billed $150 for the dispatched trip charge.
      </p>
      <p className="numbered-paragraphs no-break">
        <span>4.</span>
        Customer acknowledges their responsibility to disconnect any services with other service
        providers after EPIK services have been delivered. Customer will coordinate any disconnect
        activities to coincide with the actions taken by Customer’s chosen 3rd-party vendors
        utilized for cross-connect services. EPIK is not responsible for charges from Customer’s
        other service providers at any time whether before or after the delivery and activation of
        EPIK services.
      </p>
      <p className="numbered-paragraphs no-break">
        <span>5.</span>
        Late payment charges. EPIK will charge a 10% late fee for every 30 days past the invoice
        date that Customer has not paid the outstanding invoices. Unpaid invoices 60-days or older
        will be grounds for service disconnection. A $49.95 reconnection fee will be charged to
        customer via credit card in order to establish service after disconnection due to non
        payment.
      </p>
      <p className="numbered-paragraphs no-break">
        <span>6.</span>
        Customer acknowledges the possible involvement of a 3rd party underwriting and billing
        partner as part of the EPIK order. Customer agrees to potential one-time documentation fees
        up to $200.00 per order and also agrees to cooperate with EPIK to provide and sign all
        necessary credit and application information required to finalize and fund financing
        arrangements for EPIK services.
      </p>
      <p className="numbered-paragraphs no-break" style={{ display: 'flex' }}>
        <span>7.</span>
        Customer acknowledges and agrees to other current terms and conditions as found at &nbsp;
        <a href="https://epik.io/terms-and-conditions">https://epik.io/terms-and-conditions</a>
        {/* hidden */}
        <div hidden className="initial-box">
          <div className="inner-initial-box" />
          <div className="inner-initial-box">
            <p className="inner-box-p">Initial</p>
          </div>
        </div>
      </p>
    </div>
  );
};

export default FirstSection;
